import { createSlice } from '@reduxjs/toolkit';

import { loadImmigrationProfessional } from './immigration-professional.middleware';
import { IImmigrationProfessional } from 'api';

type ImmigrationProfessionalState = {
    entity: IImmigrationProfessional | null;
};

const initialState: ImmigrationProfessionalState = {
    entity: null,
};

export const immigrationProfessionalSlice = createSlice({
    name: 'app/immigration-professional',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(loadImmigrationProfessional.fulfilled, (state, action) => {
            state.entity = action.payload.data;
        });
    },
});

export default immigrationProfessionalSlice.reducer;
